import { getAll, put, getByKey, clear } from './utils/transactionHelpers'

export async function saveFleetData(data) {
    try {
        data = data.map((fleet, index) => {
            if (!fleet.id && fleet.salesforceID) {
                fleet.id = fleet.salesforceID
            }
            return { ...fleet, orderIndex: index }
        })

        const putPromises = data.map(fleet => put('fleets', fleet))
        await Promise.all(putPromises)
    } catch (error) {
        console.error('Error saving fleet data:', error)
        throw error
    }
}

export async function getAllFleetData() {
    try {
        const data = await getAll('fleets')

        return data.sort((a, b) => a.orderIndex - b.orderIndex)
    } catch (error) {
        console.error('Error retrieving fleet data:', error)
        return []
    }
}

export async function getFleetById(id) {
    try {
        const fleet = await getByKey('fleets', id)
        if (!fleet) {
            throw new Error(`Fleet item with ID ${id} not found`)
        }
        return fleet
    } catch (error) {
        console.error('Error retrieving fleet item by ID:', error)
        throw error
    }
}

export const deleteAllFleets = async () => {
    try {
        await clear('fleets')
        console.log('All fleets deleted successfully')
    } catch (error) {
        console.error('Error deleting all fleets:', error)
        throw error
    }
}
